import { isValueDef } from '../../../channeldef';
import { isPathMark } from '../../../mark';
import { signalOrValueRef } from '../../common';
import { wrapCondition } from './conditional';
export function zindex(model) {
  var encoding = model.encoding,
    mark = model.mark;
  var order = encoding.order;
  if (!isPathMark(mark) && isValueDef(order)) {
    return wrapCondition({
      model: model,
      channelDef: order,
      vgChannel: 'zindex',
      mainRefFn: function mainRefFn(cd) {
        return signalOrValueRef(cd.value);
      },
      invalidValueRef: undefined // zindex encoding doesn't have continuous scales and thus can't have invalid values
    });
  }
  return {};
}